import ReactGA4 from 'react-ga4';

import { getCookieName } from './cookies';


/**
 * Fa da wrapper a reactGA4, impedendo l'esecuzione dei
 * metodi se sono in un ambiente di testing
 * @param {string} op metodo richiesto
 * @param {string} data parametro da inviare
 */
const googleAnalyticsWrapper = (op, ...data) => {
  if (!process.env.GATSBY_UA_ANALYTICS) {
    return false;
  }

  const enableAnalytics = getCookieName('gdpr_analytics_on', 'false');
  const gdprPreferencesSet = getCookieName('gdpr_preferences_set', 'false');

  if (!enableAnalytics || !gdprPreferencesSet) {
    return false;
  }

  if (!ReactGA4.isInitialized) {
    ReactGA4.initialize(process.env.GATSBY_UA_ANALYTICS);
  }

  if (typeof ReactGA4[op] === 'function') {
    ReactGA4[op](...data);
  }

  return true;
};

export default googleAnalyticsWrapper;
